import { api } from "../../../utils/api";

export const editRemittanceReturns = async (id, data) => {
  try {
    await api.post(`financial-remittance-return`, data);
  } catch (e) {
    console.log(e);
  }
};
